import { createAsyncThunk } from "@reduxjs/toolkit";
import { companyService } from "@/shared/services/api/company-service";
import { IGetPermissionMembersParams } from "../types/permission-member";

export const getPermissionMembersThunk = createAsyncThunk(
  "permissionMember/getPermissionMembers",
  async (params: IGetPermissionMembersParams, thunkAPI) => {
    try {
      const response = await companyService.getPermissionMember(params.userId, {
        offset: params.offset,
        limit: params.limit,
        search: params.search,
        sortBy: params.sortBy,
      });
      
      
      return response.data;
    } catch (error: any) {
      return thunkAPI.rejectWithValue(error?.message || "Permission üyeleri alınırken hata oluştu");
    }
  }
); 